import { createSelector } from "@ngrx/store";
import { AppState } from "../reducers";

const selectPlaybackState = (state: AppState) => state.playback;

export const selectCurrentPlayback = createSelector(
  selectPlaybackState,
  (playback) => playback.currentlyPlayingUrl
);
